import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const CardContainer = styled.div`
	article {
		position: relative;
		padding: 20px 0 40px;
		max-height: 400px;
		text-align: ${props => (props.wireframe ? 'center' : 'left')};
		font-size: var(--fs-medium);
		overflow: hidden;

		h3 {
			text-align: center;
			margin-bottom: 30px;
			color: ${props => (props.wireframe ? '#FF9C46' : 'inherit')};
			color: ${props => (props.wireframe ? 'var(--orange)' : 'inherit')};
		}

		a {
			color: #ffaa66;
			color: var(--orange-light);
		}

		/* gradient layer at the end of long cards */
		&::after {
			content: '';
			display: ${props => (props.wireframe ? 'none' : 'block')};
			pointer-events: none;
			position: absolute;
			top: 75%;
			left: 0;
			bottom: 0;
			right: 0;
			background-image: linear-gradient(
				rgba(255, 255, 255, 0),
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, 1)
			);
		}
	}
`;

const CardImg = styled.div`
	width: 100%;
	height: ${props => (props.wireframe ? '200px' : '300px')};
	background-image: url(${props => props.src});
	background-size: ${props => (props.wireframe ? 'contain' : 'cover')};
	background-position: center;
	background-repeat: no-repeat;
	overflow: hidden;
	justify-self: center;
	align-self: center;
`;

const CardLink = styled.a`
	color: inherit;
	text-decoration: none;
`;

const Card = ({ imgSrc, text, title, wireframe, link }) => {
	const image = <CardImg src={imgSrc} wireframe={wireframe} />;
	const article = (
		<article>
			{title && <h3>{title}</h3>}
			<div
				dangerouslySetInnerHTML={{
					__html: text
				}}
			/>
		</article>
	);

	const withLink = element => (
		<CardLink href={link} target="_blank" rel="noopener noreferrer">
			{element}
		</CardLink>
	);

	return (
		<CardContainer wireframe={wireframe}>
			{link ? withLink(image) : image}
			{link ? withLink(article) : article}
		</CardContainer>
	);
};

Card.propTypes = {
	imgSrc: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	title: PropTypes.string
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card.js